import DocTypes from "@/store/modules/taxonomy/document-types";

export default {
  namespaced: true,
  modules: {
    DocTypes
  }
};
